import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import EmailInput from '../components/EmailInput';
import { AuthService } from '../services/auth';
import { SwatchBook } from 'lucide-react'; // Import SwatchBook icon

const authService = new AuthService();

const PasswordResetRequest = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Delay the form fade-in animation
    const timer = setTimeout(() => {
      setFormVisible(true);
    }, 250); // 1/4 second delay
    
    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      await authService.forgotPassword(email);
      // Store email in sessionStorage to pre-fill it on the confirmation page
      sessionStorage.setItem('resetEmail', email);
      // Redirect to the confirmation page
      navigate('/password-reset-confirm');
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-md mx-auto px-4">
        {/* Logo and brand name with subtle animation - stacked vertically */}
        <Link 
          to="/" 
          className="flex flex-col items-center justify-center mb-6 transform transition-transform duration-300 hover:scale-105"
        >
          <SwatchBook className="w-12 h-12 text-orange-500 mb-2" />
          <span className="text-2xl font-bold text-black">dessino.ai</span>
        </Link>

        <div 
          className={`bg-white p-6 rounded-lg shadow-sm transition-all duration-500 ease-in-out ${formVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
        >
          <h1 className="text-2xl font-bold mb-5">Reset Password</h1>
          
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4 animate-pulse">
              {error}
            </div>
          )}
          
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <EmailInput value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-black text-white py-3 rounded-md hover:bg-gray-800 transition-all duration-300 flex items-center justify-center transform hover:scale-[1.01] active:scale-[0.99]"
            >
              {loading ? (
                <span className="inline-block animate-spin rounded-full h-4 w-4 border-t-2 border-white mr-2"></span>
              ) : null}
              {loading ? 'Sending...' : 'Send Reset Code'}
            </button>
          </form>

          <p className="text-center text-sm text-gray-600 mt-6">
            Remembered your password?{' '}
            <Link to="/login" className="text-blue-500 hover:underline">
              Back to Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetRequest;